// Firebase Auth's default policy; the project configures no stricter one.
export const MIN_PASSWORD_LENGTH = 6;
